import treatsEntities from '@/business/apiTreatment/response/entities';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';
import Client from './tools/client';

export default {
  async getEntities(queryParams) {
    const url = 'user_preferences/api/v1/entities';
    return Client.get(url, {
      params: queryParams,
    })
      .then(treatsEntities)
      .catch(errorHandler);
  },
  async getTopLevelEntities(queryParams) {
    const url = 'user_preferences/api/v1/entities/toplevel';
    return Client.get(url, {
      __retry: { nbLeft: 3, timeout: 2000 },
      params: queryParams,
    })
      .then((response) => response.data)
      .catch(errorHandler);
  },
};
